angular.module('SpidApp')

.factory('SynchroRun',
        ['SPID_CONFIG', '$localStorage', 'Toaster', 'SyncRunner',
function (SPID_CONFIG, $localStorage, Toaster, SyncRunner) {
  var SynchroRun = {

    /**
    * Lance la synchronisation
    **/
    launchSync : function (){
      
      if (SPID_CONFIG.synchro.isEnabled === true) { // Sync
        var sync = function () {
            var successCb = function () {
                $localStorage.sync = new Date();
            }; // Nothing
            var errorCb = function (error) {
                console.error(error);
                Toaster.danger('<span class="bold">Problème de synchronisation</span>');
            };
            SyncRunner.sync(successCb, errorCb);
        };

        sync();
      }
    }
  };

  return SynchroRun;
}]);